"use client";

import * as React from "react";
import { format } from "date-fns";
import { DayPicker, DateRange } from "react-day-picker";
import "react-day-picker/dist/style.css";

interface DateRangePickerProps {
  onChange: (range: DateRange) => void;
  minDate?: Date;
  maxDate?: Date;
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  onChange,
  minDate,
  maxDate,
}) => {
  const today = new Date();
  const [dateRange, setDateRange] = React.useState<DateRange>({
    from: today,
    to: today,
  });
  const [currentMonth, setCurrentMonth] = React.useState<Date>(today);

  const handleDateRangeChange = (range: DateRange | undefined) => {
    if (!range) return;
    setDateRange(range);
    onChange(range);
  };

  const isDateDisabled = (date: Date) => {
    return (
      (minDate && date < minDate) || (maxDate && date > maxDate) || false
    );
  };

  const selectToday = () => {
    const todayRange = { from: today, to: today };
    setDateRange(todayRange);
    onChange(todayRange);
  };

  const resetSelection = () => {
    setDateRange({ from: undefined, to: undefined });
    onChange({ from: undefined, to: undefined });
  };

  const formatDateRange = (dateRange: DateRange) => {
    if (!dateRange.from || !dateRange.to) {
      return "Select a date range";
    }
  
    const fromMonth = format(dateRange.from, "MMMM");
    const toMonth = format(dateRange.to, "MMMM");
    const fromYear = format(dateRange.from, "yyyy");
    const toYear = format(dateRange.to, "yyyy");
  
    if (fromMonth === toMonth && fromYear === toYear) {
      return `${format(dateRange.from, "dd")} - ${format(
        dateRange.to,
        "dd MMMM yyyy"
      )}`;
    } else if (fromYear === toYear) {
      return `${format(dateRange.from, "dd MMMM")} - ${format(
        dateRange.to,
        "dd MMM yyyy"
      )}`;
    } else {
      return `${format(dateRange.from, "dd MMMM yyyy")} - ${format(
        dateRange.to,
        "dd MMMM yyyy"
      )}`;
    }
  }

  const modifiers = {
    selected: dateRange,
    today: today
  };

  return (
    <div className="p-4 pt-0 rounded-md shadow-md border dark:border-border w-full mx-auto">
      <DayPicker
        mode="range"
        selected={dateRange}
        onSelect={handleDateRangeChange}
        disabled={isDateDisabled}
        month={currentMonth}
        onMonthChange={setCurrentMonth}
        className="p-2"
        showOutsideDays
        weekStartsOn={1}
        modifiers={modifiers}
        modifiersStyles={{
          selected: {
            backgroundColor: "#cdc944", // Tailwind `bg-red-600`
            color: "white",
            borderRadius: "50%",
          },
          today: {
            fontWeight: "bold",
           
          },
          hover: {
            backgroundColor: "#cdc944",
          }
        }}
      />

      {/* Seçili tarih bilgisi */}
      <div className="text-center mt-4 font-medium text-lg">
        {dateRange.from && dateRange.to
          ? `${formatDateRange(dateRange)}`
          : "Select a date range"}
      </div>

      <div className="flex justify-between mt-2">
        <button
          type="button"
          onClick={selectToday}
          className="text-yellow-500 font-bold hover:underline"
        >
          Today
        </button>

        <button
          type="button"
          onClick={resetSelection}
          className="text-yellow-500 font-bold hover:underline"
        >
          Reset
        </button>
      </div>
    </div>
  );
};
